type PluralRules = {
  [key: string]: string;
};

export const pluralize = (
  count: number,
  singular: string,
  irregulars: PluralRules = {},
): string => {
  if (count === 1) {
    return `${count} ${singular}`;
  } else {
    if (Object.hasOwn(irregulars, singular)) {
      return `${count.toLocaleString()} ${irregulars[singular]}`;
    } else {
      // Basic pluralization rule: add "s" at the end.
      return `${count.toLocaleString()} ${singular}s`;
    }
  }
};
